import { actionData } from './actions';

export const track = action => {
  const eventName = actionData[action].eventName;
  window.analytics.track(eventName);
};

export const identify = (id, traits, cb) => window.analytics.identify(id, traits, {}, cb);

const sendToSegment = (action, userId, data = {}) => {
  if (window.analytics) {
    if (userId || data.email) {
      identify(userId, data, () => track(action));
    } else {
      track(action);
    }
  }
  console.warn('Segment could not be loaded');
};

export default sendToSegment;
